import { homePageBreadcrumbs } from 'utils/breadcrumbs';

export const breadcrumbs = [
  homePageBreadcrumbs,
  {
    text: 'Кормовые добавки',
  },
  {
    link: '/registry/feed/requests',
    text: 'Список заявок',
  },
  {
    text: 'Просмотр',
  },
];
